/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type Params } from 'react-router-dom';

import { TeamMembershipRolePermissions } from '@fai/friendli-suite/features/common/team-membership-role';
import { getTeamRole } from '@fai/friendli-suite/features/routes/loaders/apis/client-team';
import { customJson } from '@fai/third-party/react-router-dom';

export const strictCheckIfIsTeamOwner = async ({ params }: { params: Params<'teamId'> }) => {
  const teamId = params.teamId ?? '';
  const role = await getTeamRole({ teamId });

  if (!TeamMembershipRolePermissions(role).isAboveAdmin) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw customJson(
      {
        message: 'accessible for team owner',
      },
      { status: 403 }
    );
  }

  return null;
};
